import React from "react";
import { useResortMenuStore } from "../../store/resortMenuStore";

type SubMeniItemProps = {
  title: string;
  options: string[];
  index: number;
};

const SubMeniItem = ({ title, index, options }: SubMeniItemProps) => {
  const { openSubMenuIndex, setOpenSubMenuIndex, toggleMenuOpen, setParams, closeSubMenu, isInParams} = useResortMenuStore();

  const isOpen = openSubMenuIndex == index;

  const toggleSubMenu = () => {
    if ( isOpen ) {
      closeSubMenu()
    } else {
      setOpenSubMenuIndex(index);
    }
    
  };

  const handleOptionClick = (event: React.MouseEvent, item: string, title : string) => {
    event.stopPropagation();
    //closeSubMenu()
    if (!event.currentTarget) return;

    const newTitle = mapOptionToACF(title)
    if ( newTitle == undefined ) return

    setParams({ 
      name : newTitle,  
      value : item,
      label : item
    });
    
  };

  const mapOptionToACF = (title : string) => {
    const titleLowered = title.toLowerCase()
    switch ( titleLowered ) {
      case 'resort size' : 
        return 'size';

      default : return titleLowered;
    }
  }

  return (
      <div className='subMenuMainItemContainer'>
        <div 
          onClick={(event) => {
            event.preventDefault();
            toggleSubMenu();
          }}
          className='subMenuTitle'>{title}</div>
        <div className='subMenuOptionsContainer'>
          {isOpen &&
            (options as []).map((item, index) => (
              <div
                onClick={(event) => {
                  handleOptionClick(event, item, title);
                }}
                key={index}
              >
                <span className={ isInParams(item) ? 'selectCircle yes' : 'selectCircle no' }></span>{item}
              </div>
            ))}
        </div>
      </div>
  );
};

export default SubMeniItem;
